<template>
    <div class="d-flex align-items-center justify-content-start flex-wrap">
        <p>Add color to items:</p>
        <template v-for="color in colors">
            <ItemColor v-bind:key="color" :color="color" @click="markItems(color);"></ItemColor>
        </template>
    </div>
</template>
<script>
import ItemColor from "@/components/forecasts/pages/sections/itemsColor/ItemColor";
import forecastsService from "@/components/forecasts/forecastsService";
import { PROFILES } from "@/plugins/AccessUserPlugin";

export default {
    components: {
        ItemColor
    },
    props: ["items", "forecast"],
    data() {
        return {
            colors: ["#FF7E7E", "#FFE67E", "#7E7EFF", "#B0FF7E", "#7EFAFF", "#FF7EE6", "#FFBE7E", "#7EE1FF", "#CFEA75", "#D27EFF", ""]
        };
    },
    methods: {
        markItems(color) {
            if (this.hasAccessByProfile(PROFILES.FORECAST_MANAGER)) {
                forecastsService.updateItemsColor(this.forecast, this.items, color);
            } else if (this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR)) {
                forecastsService.updateItemsColorFw(this.forecast, this.items, color);
            }
            this.$emit("colorsChanged", color);
        }
    }
};
</script>
<style scoped lang="scss">
div {
    margin: 10px 0 0;
}
p {
    margin: 0;
}
p,
button {
    margin: 5px 7px;
}
</style>



// WEBPACK FOOTER //
// ItemColors.vue?4dc36992